import axios from 'axios';

const url = '/api/notes';


const noteDashboardActions = {
    SET_COUNT_ACTIVE_NOTE: 'SET_COUNT_ACTIVE_NOTE',

    getSearchNotes: params => {
        return dispatch => {
            return axios.get(`${url}/search-notes`, { params });
        }
    },

    createNote: params => {
        return dispatch => {
            return axios.post(`${url}/create-note`, params);
        }
    },

    softDeleteNote: id => {
        return dispatch => {
            return axios.delete(`${url}/soft-delete-note/${id}`);
        }
    },
    deleteNote: id => {
        return dispatch => {
            return axios.delete(`${url}/delete-note/${id}`);
        }
    },
    updateNote: (id, params) => {
        return dispatch => {
            return axios.put(`${url}/update-note/${id}`, params);
        }
    },
    getEnum: () => {
        return dispatch => {
            return axios.get(`${url}/enums`);
        }
    },
    getDetail: (id) => {
        return dispatch => {
            return axios.get(`${url}/note-detail/${id}`);
        }
    },
    getNotes: (noteType) => {
        return dispatch => {
            return axios.get(`${url}/get-notes/${noteType}`);
        }
    },
    getEntityId: (id, noteType) => {
        return dispatch => {
            return axios.get(`${url}/get-entity-id?id=${id}&noteType=${noteType}`);
        }
    },

    getAssignUser: (companyId, visibility) => {
        return dispatch => {
            const query = visibility ? `?companyId=${companyId}&visibility=${visibility}` : `?companyId=${companyId}`;
            return axios.get(`${url}/assign-user${query}`);
        }
    },

    unActiveNote: (id) => {
        return dispatch => {
            return axios.put(`${url}/unactive-note/${id}`);
        }
    },

    activeNote: (id) => {
        return dispatch => {
            return axios.put(`${url}/active-note/${id}`);
        }
    },

    getActiveNote: () => {
        return dispatch => {
            return axios.get(`${url}/active-notes`);
        }
    },

    countActiveNote: () => {
        return (dispatch) => {
            return axios.get(`${url}/count-active-note`).then(res => {
                const data = res.data;
                dispatch({ type: noteDashboardActions.SET_COUNT_ACTIVE_NOTE, data });
            });
        }
    }
}

export default noteDashboardActions;